import { AnyObject, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import arrayMutators from "final-form-arrays";
import { FormApi } from "final-form";
import { IconNames } from "components/Icon/Icon";
import EditHeader from "../EditHeader/EditHeader";
import HeaderButtonsEdit from "../EditHeader/HeaderButtonsEdit";
import FormScrollError from "../FormScrollError/FormScrollError";

interface Props {
  onSubmit: (values: any) => Promise<any>;
  initialValues: any;
  onCancel?: () => void;
  onDelete?: () => void;
  render: (
    values: any,
    form: FormApi<any, Partial<any>>,
    handleSubmit: (
      event?: Partial<
        Pick<React.SyntheticEvent, "preventDefault" | "stopPropagation">
      >,
    ) => Promise<AnyObject | undefined> | undefined,
  ) => React.ReactNode;
  headerIcon?: IconNames;
  subtitleLabel?: string;
  noHeader?: boolean;
  additionalMutators?: any;
  i18nNamespace?: string;
}

function CrudForm({
  onSubmit,
  initialValues,
  onCancel,
  onDelete,
  render,
  headerIcon = "UserIcon",
  subtitleLabel,
  noHeader = false,
  additionalMutators = {},
  i18nNamespace = "common",
}: Props) {
  const { t } = useTranslation();

  const onSubmitWrapper = async (values: any) => {
    const res = await onSubmit({ data: values });
    return res;
  };

  return (
    <Form
      onSubmit={onSubmitWrapper}
      mutators={{
        setFieldValue: ([field]: any, state: any, utils: any) => {
          utils.changeValue(state, field.field, () => field.value);
        },
        ...arrayMutators,
        ...additionalMutators,
      }}
      subscription={{ values: true, submitting: true, pristine: true }}
      initialValues={initialValues}
      render={({ handleSubmit, values, form }) => {
        return (
          <div className="mx-auto max-w-full py-4 px-4 text-slate-500 text-base">
            {/* Header */}
            {!noHeader && (
              <EditHeader
                title={t(
                  `${i18nNamespace}.${
                    initialValues && initialValues.id ? "edit" : "add"
                  }`,
                )}
                subtitle={subtitleLabel || ""}
                icon={headerIcon}
                HeaderButtonsEdit={
                  <HeaderButtonsEdit
                    inHeader
                    onSubmit={handleSubmit}
                    onCancel={onCancel}
                    onDelete={onDelete}
                  />
                }
              />
            )}
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <FormScrollError />

              <div className="mt-2">{render(values, form, handleSubmit)}</div>
              <HeaderButtonsEdit onSubmit={handleSubmit} onCancel={onCancel} />
            </form>
          </div>
        );
      }}
    />
  );
}
export default CrudForm;
